export const columnsDataDpOverview = [
    {
        Header: 'ID',
        accessor: 'dpid'
    },
    {
        Header: 'NAME',
        accessor: 'dpName',
    },
    {
        Header: 'TYPE',
        accessor: 'dpType',
    },
    {
        Header: 'RANGE',
        accessor: 'dpRange',
    },
    {
        Header: 'PITCH',
        accessor: 'pitch',
    },
    {
        Header: 'UNIT',
        accessor: 'unit',
    },
    {
        Header: 'ACTIONS',
        accessor: 'actions',
    },
];
